import { SupplierRepresentativeCreatableInterface } from '../interfaces/supplier-representative-creatable.interface';
import { PickType } from '@nestjs/swagger';
import { SupplierRepresentativeDto } from './supplier-representative.dto';

export class SupplierRepresentativeCreateDto
  extends PickType(SupplierRepresentativeDto, ['supplierId', 'userId'])
  implements SupplierRepresentativeCreatableInterface {}
